import React from "react"
import _ from "underscore";
import M from "../../../strings";
import { Screen } from "../../components/layout";
import { ACTION_TYPES } from "../../components/mobile/actions";
import MobileLayout from "../../components/mobile/layout";
import Secure from "../../components/secure";
import * as ui from "../../utils/ui";
import Searchbar from "../../components/mobile/searchbar";
import * as _query from "../../../framework/query";
import { connect } from "../../../utils/aj-react";
import { getDefaultState, RetailersStore } from "../../../stores/retailers";
import { getRetailers } from "../../../actions/retailers";
import { format, optional } from "../../../utils/lang";
import { isNotEmpty } from "../../../framework/utils";
import * as RetailersUtils from "../../utils/retailers";
import * as SurveyUtils from "../../utils/surveys";
import GradedValue, { GRADE_TYPES } from "../../components/mobile/gradedValue";

export default class StoresSummary extends Screen {
    constructor(props) {
        super(props);

        const query = _query.create({rowsPerPage: 100});
        query.on("change", this.getData.bind(this));
        connect(this, RetailersStore, _.extend(getDefaultState(), {query: query}));
    }

    componentDidMount() {
        this.getData();
    }

    getData() {
        const query = this.state.query;
        getRetailers({query: query});
    }

    onKeywordChange(keyword) {
        const query = this.state.query;
        query.setKeyword(keyword);
    }

    onItemClick(id) {
        ui.navigate("/app/store/" + id);
    }

    render() {
        const leftActions=[
                {
                    id: "home",
                    type: ACTION_TYPES.ICON,
                    icon: "close",
                    onClick: () => ui.navigate(""),
                },
            ],
            retailers = optional(() => this.state.retailers.rows, []);

        return(
            <Secure>
                <MobileLayout
                    title={M("retailers")}
                    leftActions={leftActions}
                >
                    <div
                        className="stores-summary"
                    >
                        <Searchbar
                            className="stores-summary__searchbar"
                            onChange={this.onKeywordChange.bind(this)}
                        />
                        <div
                            className="stores-summary__items"
                        >
                            {isNotEmpty(retailers) ? (
                                _.map(retailers, retailerSummary => {
                                    const store = retailerSummary.store,
                                        description = RetailersUtils.getStoreDescription(store),
                                        address = RetailersUtils.formatStoreAddress(store),
                                        surveySummaries = optional(retailerSummary.surveySummaries, []),
                                        surveyCount = isNotEmpty(surveySummaries)
                                            ? format(M("retailersSurveyCountWithNumber"), surveySummaries.length)
                                            : M("noSurveys"),
                                        currentSurveySummary = optional(_.find(surveySummaries, s => s.survey.id === store.currentSurveyId), {}),
                                        currentScore = optional(() => SurveyUtils.getScoreValue(currentSurveySummary.survey.lastScore), 0),
                                        currentGrade = SurveyUtils.gradeScore(currentScore);


                                    return (<div
                                            key={"store-summary-item-" + store.id}
                                            className="stores-summary__item"
                                            onClick={this.onItemClick.bind(this, store.id)}
                                        >
                                            <div
                                                className={"store-summary__item-score store-summary__item-score--grade-" + currentGrade}
                                            >
                                                <GradedValue
                                                    className="store-summary__item-score-value"
                                                    gradeType={GRADE_TYPES.SCORE}
                                                    value={currentScore}
                                                />
                                            </div>
                                            <div
                                                className="stores-summary__item-info"
                                            >
                                                <div
                                                    className="stores-summary__item-description"
                                                >
                                                    {description}
                                                </div>
                                                <div
                                                    className="stores-summary__item-address"
                                                >
                                                    {address}
                                                </div>
                                                <div
                                                    className="stores-summary__item-survey-count"
                                                >
                                                    {surveyCount}
                                                </div>
                                            </div>
                                        </div>)
                                })
                            ) : (
                                <div className="p-5 text-center">
                                    {M("noSurveys")}
                                </div>
                            )}
                        </div>
                    </div>
                </MobileLayout>
            </Secure>
        )
    }
}